import log from "loglevel";
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Breadcrumb } from "react-bootstrap";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import ProgrammingActivity from "../../../Programming/Student/Program/Program.jsx";
import OtherActivity from "../../../../../../Screens_old/OtherLab/student/index";
import JSZip from "jszip";
import displayGlobalMessage from "Utils/DisplayGlobalMessage.js";

function ActivityContainer({ courseId }) {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Shared data from ExamProvider
  const { labData, studentData, isExam, handleTimeUp, handleLabTimeUp } = useOutletContext() || {};

  const [newActivity, setNewActivity] = useState(
    true
  );
  const Activity = null;

  // URL path is splitted based on "/" and extracted into array
  // so, later we use the activity Type and activityID that is contained in the URL
  let urlArray = location.pathname;
  if (urlArray[urlArray.length - 1] === "/") {
    //Removing the "/" from last part of URL
    urlArray = urlArray.substring(0, urlArray.length - 1);
  }
  urlArray = urlArray.split("/");

  //State variable common accross all activities
  const [labID, setLabID] = useState(params.labId);
  const [activity_title, setActivityTitle] = useState(location.activityTitle);
  const [labAvailableTill, setAvailableTill] = useState(
    labData?.available_till || location.available_till
  );

  // Sync available_till when labData changes (e.g. from WebSocket lab_settings_changed)
  useEffect(() => {
    if (labData?.available_till) {
      setAvailableTill(labData.available_till);
    }
  }, [labData?.available_till]);
  const [activity_description, setActivityDescription] = useState("");
  //Setting the Activity ID from the URL if it's "newActivity" setting it to null
  let defValueOfActivityId =
    urlArray[urlArray.length - 1] !== "newActivity"
      ? urlArray[urlArray.length - 1]
      : null;
  const [activityID, setActivityID] = useState(defValueOfActivityId);
  //Assuming that the 2nd last part of the URL contains the ActivityType and last part of URL contains activityID
  let defValueOfActivityType = null;
  if (
    urlArray[urlArray.length - 2] === "programming" ||
    urlArray[urlArray.length - 2] === "virtual" ||
    urlArray[urlArray.length - 2] === "other"
  ) {
    defValueOfActivityType = urlArray[urlArray.length - 2];
  }
  const [activityType, setActivityType] = useState(defValueOfActivityType);

  //******************PROGRAMMING ACTIVITY Fields Starts From Here****************/
  //states for main page
  const [ProgrammingActivityDetails, setProgrammingActivityDetails] =
    useState(null);
  const [AccessControlsProgActivity, setAccessControlsProgActivity] =
    useState(null);
  //State to store if the instructor has provided additional files for the programming activity
  const [provideAdditionalFiles, setProvideAdditionalFiles] = useState(false);
  //State to store the additional files provided by the instructor
  const [instructorAdditionalFiles, setInstructorAdditionalFiles] = useState({
    C: [],
    "C++": [],
    Simplecpp: [],
  });

  const [document, setDocument] = useState(null);
  const [displayRunWithoutSubmitButton, setDisplayRunWithoutSubmitButton] = useState(true);

  //******************PROGRAMMING ACTIVITY Fields Ends Here****************/

  //******************VIRTUAL ACTIVITY Fields Starts From Here****************/
  //EXPERIMENT DETAILS for Virtual Activity

  //Evaluation Scripts and Docker Configuration for Virtual Activity

  //Add Script Fields for Virtual Activity

  //******************VIRTUAL ACTIVITY Fields Ends Here****************/
  //******************Other ACTIVITY Fields Starts From Here****************/
  const [otherActivityDetails, setOtherActivityDetails] = useState(null);
  //******************Other ACTIVITY Fields Ends Here****************/

  useEffect(() => {
    if (activityID) {
      const url =
        constants.base_url +
        "/lab/activity/" +
        activityID +
        "?type=" +
        activityType;
      const fetchData = async () => {
        try {
          const response = await httpService.get(url);

          if (activityType === "programming") {
            setProgrammingActivityDetails(response.data?.program_data);
            setAccessControlsProgActivity(response.data?.access_control_vars);
            setActivityDescription(response.data?.program_data?.description);
            setActivityTitle(response.data?.program_data?.name);
            setProvideAdditionalFiles(
              response.data?.program_data?.is_instructor_additonal_file_present
            );
            setDisplayRunWithoutSubmitButton(
              response.data?.program_data?.display_run_without_submit_button
            );

            // Extract and set additional files if present
            const {
              c_instructor_additional_file,
              cpp_instructor_additional_file,
              simplecpp_instructor_additional_file,
            } = response.data.program_data;

            const cFiles = await extractAndSetFiles(
              c_instructor_additional_file,
              "C"
            );
            const cppFiles = await extractAndSetFiles(
              cpp_instructor_additional_file,
              "C++"
            );
            const simplecppFiles = await extractAndSetFiles(
              simplecpp_instructor_additional_file,
              "Simplecpp"
            );

            setInstructorAdditionalFiles({
              C: cFiles,
              "C++": cppFiles,
              Simplecpp: simplecppFiles,
            });

            const document = await downloadFile(
              response.data.program_data.document
            );
            setDocument(document);
          } else if (activityType === "virtual") {
            // Handle virtual activity type
          } else if (activityType === "other") {
            setOtherActivityDetails(response.data?.other_activity);
            setActivityDescription(response.data?.other_activity?.description)
            setActivityTitle(response.data?.other_activity?.name)
          }
        } catch (error) {
          log.error("Error fetching activity:", error);
          if (error?.response?.data?.detail?.[0]) {
            displayGlobalMessage(
              error?.response?.data?.detail?.[0],
              "error",
            );
          } else if (error?.response) {
            displayGlobalMessage(
              `${error?.response?.status} ${error?.response?.statusText}`,
              "error",
            );
          } else {
            displayGlobalMessage(
              "An error occurred while fetching the activity.",
              "error",
            );
          }
        }
      };

      fetchData();
    }
  }, [activityID, activityType]);

  const extractAndSetFiles = async (fileUrl, languageKey) => {
    if (!fileUrl) return [];

    try {
      const zipResponse = await httpService.get(fileUrl, {
        responseType: "arraybuffer",
      });
      const zip = new JSZip();
      const zipContent = await zip.loadAsync(zipResponse.data);
      const files = [];

      for (const fileName in zipContent.files) {
        const file = zipContent.files[fileName];
        if (!file.dir) {
          const fileData = await file.async("blob");
          files.push(new File([fileData], fileName));
        }
      }
      return files;
    } catch (error) {
      log.error(`Error extracting ${languageKey} files:`, error);
      return [];
    }
  };

  //Function to download a normal file and set it to the state
  const downloadFile = async (fileUrl) => {
    if (!fileUrl) return null;

    try {
      // Presigned URLs are full URLs — use fetch directly
      const isAbsoluteUrl = fileUrl.startsWith('http://') || fileUrl.startsWith('https://');
      if (isAbsoluteUrl) {
        const resp = await fetch(fileUrl);
        const blob = await resp.blob();
        const cleanUrl = fileUrl.split('?')[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
        return new File([blob], fileName, { type: blob.type });
      }
      // Make a GET request to the fileUrl, expecting a blob response
      const fileResponse = await httpService.get(fileUrl, {
        responseType: "blob",
      });
      const url = fileResponse.config.url;
      const fileName = url.substring(url.lastIndexOf("/") + 1);
      // Create a new File object with the response data and the provided filename
      const file = new File([fileResponse.data], fileName);
      return file;
    } catch (error) {
      log.error(`Error downloading file`, error);
      return null;
    }
  };

  return (
    <div>
      {courseId && <Breadcrumb>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs/${labID}/`}>
            {labData?.title || ""}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{activity_title}</Breadcrumb.Item>
      </Breadcrumb>}

      {activityType === "programming" ? (
        // <div>Programming</div>
        <>
          <ProgrammingActivity
            programId={activityID}
            courseId={courseId}
            labID={labID}
            activity_title={activity_title}
            activity_description={activity_description}
            AccessControlsProgActivity={AccessControlsProgActivity}
            ProgrammingActivityDetails={ProgrammingActivityDetails}
            setAccessControlsProgActivity={setAccessControlsProgActivity}
            provideAdditionalFiles={provideAdditionalFiles}
            instructorAdditionalFiles={instructorAdditionalFiles}
            document={document}
            studentData={studentData}
            isExam={isExam}
            displayRunWithoutSubmitButton={displayRunWithoutSubmitButton}
            handleTimeUp={handleTimeUp}
          />
        </>
      ) : (
        <div>
          {activityType === "virtual" ? (
            <div>Virtual Activity for Student Side Needs to be Implemented</div>
          ) : (
            <div>
              {activityType === "other" ? (
                <OtherActivity
                  otherActivityDetails={otherActivityDetails}
                  labAvailableTill={labAvailableTill}
                  labId={labID}
                  isExam={isExam}
                  handleTimeUp={handleTimeUp}
                  handleLabTimeUp={handleLabTimeUp}
                  studentData={studentData}
                />
              ) : (
                <div></div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
export default ActivityContainer;
